import { render, staticRenderFns } from "./icon-error.vue?vue&type=template&id=03e67b14"
import script from "./icon-error.vue?vue&type=script&lang=ts"
export * from "./icon-error.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports